module.exports = __webpack_public_path__ + "static/img/17.350ad99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/17.jpg
// module id = i1Vr
// module chunks = 16